<div class="modal-footer">
    <button *ngIf="!hideCancel" type="button" class="btn btn-outline-green" [disabled]="cancelDisabled"
        (click)="onCancelClick.emit()">
        {{ cancelLabel }}
    </button>

    <button *ngIf="!hideSave" type="submit" class="btn btn-green" [disabled]="saveDisabled" (click)="onSaveClick.emit()">
        {{ saveLabel }}
    </button>

</div>
